import React, { useEffect, useState, useContext } from "react";
import { Table, Tag, Button, Modal } from "antd";
import { instance } from "utils/axios";
import { AuthContext } from "contexts";
import { useNavigate } from "react-router-dom";
import logo from "assets/images/logo.jpg";

const C = { purple: "#7B2FBE", yellow: "#FFD600" };

// ── Result Modal ──────────────────────────────────────────────────────────────
function ResultModal({ open, onClose, stage, finAid, name, tuitionReady }) {
  if (!stage) return null;

  const isAccept = stage.status === "Accept";
  const isStage13 = stage.stageId === 13;

  return (
    <Modal open={open} onCancel={onClose} footer={null} centered width={560} styles={{ body: { padding: 0 } }}>
      <div style={{ fontFamily: "'Raleway','Segoe UI',sans-serif", borderRadius: 8, overflow: "hidden" }}>

        <div style={{ padding: "32px 32px 24px", borderBottom: "1px solid #f0eaff" }}>
          <img src={logo} alt="Томүжин" style={{ width: 120, objectFit: "contain", marginBottom: 24, display: "block" }} />

          <p style={{ color: "#5c1090", fontSize: 18, fontWeight: 700, margin: "0 0 20px 0" }}>
            САЙН УУ, {stage.firstName || name},
          </p>

          {isAccept && !isStage13 && (
            <>
              <p style={{ color: "#5c1090", fontSize: 15, lineHeight: 1.7, margin: "0 0 16px 0" }}>
                Томүжин Алтернатив Сургуулийн элсэлтийн алба таны илгээсэн 1-р шатны өргөдөлтэй бүрэн танилцаж таны талаарх илүү ихийг мэдэж авах сонирхолтой байгаа тул элсэлтийн <strong>2-р шатанд оролцохыг урьж байна.</strong>
              </p>
              <p style={{ color: "#5c1090", fontSize: 15, lineHeight: 1.7, margin: "0 0 16px 0" }}>
                Элсэлтийн 2-р шат Монгол хэл, Англи хэл, Математикийн шалгалт, ярилцлага, бататгах сорил гэсэн хэсгүүдээс бүрдэх ба хүрэлцэн ирэхдээ үзэг, бал, биед эвтэйхэн хувцастай байхад болно.
              </p>
              <p style={{ color: "#5c1090", fontSize: 15, lineHeight: 1.7, margin: "0 0 8px 0" }}><strong>2-р шатны хуваарь:</strong></p>
              <ul style={{ color: "#5c1090", fontSize: 15, lineHeight: 2, margin: "0 0 20px 0", paddingLeft: 20 }}>
                <li>2026-2027 онд <strong>6-9-р ангид</strong> элсэн суралцах сурагчид — 3-р сарын 28-ний Бямба гарагийн <strong>11 цагаас</strong></li>
                <li>2026-2027 онд <strong>10-11-р ангид</strong> элсэн суралцах сурагчид — 3-р сарын 28-ний Бямба гарагийн <strong>14 цагаас</strong></li>
              </ul>
            </>
          )}

          {isAccept && isStage13 && (
            <>
              <p style={{ color: "#5c1090", fontSize: 15, lineHeight: 1.7, margin: "0 0 16px 0" }}>
                Томүжин Алтернатив сургуульд суралцах хүслээ илэрхийлж, элсэлтийн бүх үе шатанд оролцсон танд баярлалаа.
              </p>
              <p style={{ color: "#5c1090", fontSize: 15, lineHeight: 1.7, margin: "0 0 16px 0" }}>
                Бид таны 1-р шатны өргөдөл болон 2-р шатны шалгалтын үр дүнг нягтлан үзсэний үндсэн дээр 2026–2027 оны хичээлийн жилийн элсэлтэд амжилттай <strong>ТЭНЦСЭН</strong> болохыг баяртайгаар мэдэгдэж байна.
              </p>

              {/* tuition бэлэн → төлбөр, үгүй → finAid эсвэл standard */}
              {tuitionReady ? (
                <p style={{ color: "#5c1090", fontSize: 15, lineHeight: 1.7, margin: "0 0 16px 0" }}>
                  Таны сургалтын төлбөрийн мэдээлэл бэлэн болсон. Порталаас дэлгэрэнгүйг харна уу.
                </p>
              ) : finAid ? (
                <p style={{ color: "#5c1090", fontSize: 15, lineHeight: 1.7, margin: "0 0 16px 0" }}>
                  Таны 1-р шатны өргөдөлд санхүүгийн дэмжлэг хүссэн тул асран хамгаалагч дараах формыг зааврын дагуу бөглөж, илгээнэ үү.
                </p>
              ) : (
                <p style={{ color: "#5c1090", fontSize: 15, lineHeight: 1.7, margin: "0 0 16px 0" }}>
                  Тун удахгүй бид танд төлбөр болон бүртгэлийн дэлгэрэнгүй мэдээллийг имэйлээр илгээх болно. Томүжингийн хамт олны нэг хэсэг болж байгаад баяртай байна.
                </p>
              )}
            </>
          )}

          {!isAccept && (
            <>
              <p style={{ color: "#5c1090", fontSize: 15, lineHeight: 1.7, margin: "0 0 16px 0" }}>
                Томүжин Алтернатив сургуульд суралцах хүслээ илэрхийлж, элсэлтийн үе шатанд оролцсон танд баярлалаа.
              </p>
              <p style={{ color: "#5c1090", fontSize: 15, lineHeight: 1.7, margin: "0 0 16px 0" }}>
                {isStage13
                  ? "Бид таны 1-р шатны өргөдөл болон 2-р шатны шалгалтын үр дүнг нягтлан үзсэний үндсэн дээр энэ удаа тэнцээгүй болохыг харамсалтайгаар мэдэгдэж байна."
                  : "Бид таны 1-р шатны өргөдлийг нягтлан үзсэний үндсэн дээр энэ удаа тэнцээгүй болохыг харамсалтайгаар мэдэгдэж байна."}
              </p>
              <p style={{ color: "#5c1090", fontSize: 15, lineHeight: 1.7, margin: "0 0 16px 0" }}>
                Цаашдын суралцах замналдаа зорилгодоо хүрч, мөрөөдлөө биелүүлэхийн төлөө тууштай урагшилна гэдэгт итгэлтэй байна.
              </p>
            </>
          )}

          {/* CTA товч: tuition бэлэн → портал; finAid → jotform; бусад → байхгүй */}
          {isAccept && isStage13 && tuitionReady && (
            <div style={{ textAlign: "center", margin: "8px 0 16px" }}>
              <a href="https://portal.tomujin.edu.mn" target="_blank" rel="noreferrer"
                style={{ display: "inline-block", background: "#5c1090", color: "#fff", fontSize: 14, fontWeight: 700, textDecoration: "none", padding: "12px 28px", borderRadius: 4 }}>
                Портал руу нэвтрэх →
              </a>
            </div>
          )}
          {isAccept && isStage13 && !tuitionReady && finAid && (
            <div style={{ textAlign: "center", margin: "8px 0 16px" }}>
              <a href="https://form.jotform.com/260808191613456" target="_blank" rel="noreferrer"
                style={{ display: "inline-block", background: "#5c1090", color: "#fff", fontSize: 14, fontWeight: 700, textDecoration: "none", padding: "12px 28px", borderRadius: 4 }}>
                Санхүүгийн өргөдөл бөглөх →
              </a>
            </div>
          )}

          <p style={{ color: "#5c1090", fontSize: 15, lineHeight: 1.7, margin: "20px 0 4px 0" }}>Хүндэтгэсэн,</p>
          <p style={{ color: "#5c1090", fontSize: 15, lineHeight: 1.7, margin: "0" }}>
            Томүжин Алтернатив Сургуулийн элсэлтийн алба
          </p>
        </div>

        <div style={{ background: "#f2cd30", padding: "14px 32px", display: "flex", alignItems: "center", gap: 24 }}>
          <a href="http://www.facebook.com/TomujinAlternativeSchool" target="_blank" rel="noreferrer"
            style={{ textDecoration: "none", color: "#000", fontSize: 12, fontWeight: 700, display: "flex", alignItems: "center", gap: 6 }}>
            <img src="https://cdn-images.mailchimp.com/icons/social-block-v2/light-facebook-48.png" width={20} height={20} alt="" />
            FOLLOW US!
          </a>
          <a href="http://instagram.com/tomujinalternativeschool" target="_blank" rel="noreferrer"
            style={{ textDecoration: "none", color: "#000", fontSize: 12, fontWeight: 700, display: "flex", alignItems: "center", gap: 6 }}>
            <img src="https://cdn-images.mailchimp.com/icons/social-block-v2/light-instagram-48.png" width={20} height={20} alt="" />
            LET'S CONNECT
          </a>
          <a href="http://join.tomujin.edu.mn" target="_blank" rel="noreferrer"
            style={{ textDecoration: "none", color: "#000", fontSize: 12, fontWeight: 700, display: "flex", alignItems: "center", gap: 6 }}>
            <img src="https://cdn-images.mailchimp.com/icons/social-block-v2/light-link-48.png" width={20} height={20} alt="" />
            VISIT OUR WEB
          </a>
        </div>

      </div>
    </Modal>
  );
}

// Сонгосон хүүхдийг refresh хооронд хадгална (жагсаалттай тулгаж баталгаажуулна)
const readStoredChildId = () => {
  try { return Number(localStorage.getItem("selectedApplicantId")) || null; } catch { return null; }
};
const storeChildId = (id) => {
  try { localStorage.setItem("selectedApplicantId", String(id)); } catch { }
};

// ── Main ──────────────────────────────────────────────────────────────────────
function ApplicantHome() {
  const { state } = useContext(AuthContext);
  const name = state.studentInfo?.profile?.firstName;
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [stages, setStages] = useState([]);
  const [finAid, setFinAid] = useState(false);
  const [modalStage, setModalStage] = useState(null);
  const [tuition, setTuition] = useState(null);
  const [tuitionLoading, setTuitionLoading] = useState(false);

  // Олон хүүхэдтэй эцэг эхийн логин: нэг хаягнаас бүх хүүхдийн явцыг хянана
  const [children, setChildren] = useState([]);
  const [selectedId, setSelectedId] = useState(null); // null = хараахан тодроогүй
  const multiChild = children.length > 1;
  const selectedChild = children.find(c => c.id === selectedId);
  // Хүүхэд сонгогдсон үед бүх хүсэлтэд нь дагуулна; сонгогдоогүй (хуучин
  // урсгал) үед параметргүй — backend одоогийн шигээ ажиллана
  const childQ = selectedId ? `?applicantId=${selectedId}` : "";

  useEffect(() => {
    instance({ method: "get", url: "/applicant/children" })
      .then((res) => {
        const list = res.data || [];
        setChildren(list);
        const stored = readStoredChildId();
        const pick = list.find(c => c.id === stored) || list[0];
        setSelectedId(pick ? pick.id : 0);
      })
      .catch(() => setSelectedId(0)); // endpoint амжилтгүй → хуучин урсгалаар
  }, []);

  const handleSelectChild = (id) => {
    if (id === selectedId) return;
    storeChildId(id);
    setStages([]);
    setTuition(null);
    setFinAid(false);
    setSelectedId(id);
  };

  useEffect(() => {
    if (selectedId === null) return;
    setLoading(true);
    instance({ method: "get", url: `/applicant2/status${childQ}` })
      .then((res) => {
        const { stages: s, applicant } = res.data || {};
        setFinAid(!!applicant?.finAid);
        setStages(s || []);
      })
      .catch(() => { })
      .finally(() => setLoading(false));
  }, [selectedId]);

  useEffect(() => {
    const s13 = stages.find(s => s.stageId === 13 && s.resultSent && s.status === "Accept");
    // 1-р ангийн (бага сургуулийн) элсэлт — stage 14
    const s14 = stages.find(s => s.stageId === 14 && s.resultSent && s.status === "Accept");
    if (!s13 && !s14) return;

    setTuitionLoading(true);
    instance({ method: "get", url: `/applicant/tuition${childQ}` })
      .then(res => {
        setTuition(res.data);
        // 1-р анги: төлбөр хараахан үүсээгүй үед л конфетти хуудас шууд угтана.
        // Төлбөр үүссэний дараа ердийн адил төлбөрийн блоктой нүүр харагдана.
        // Олон хүүхэдтэй үед шууд шилжүүлэхгүй — сонгогчоо алдахгүйн тулд
        // "Хариу харах" товчоор орно.
        if (s14 && !s13 && !res.data && !multiChild) navigate(`/decision${childQ}`);
      })
      .catch(() => {
        setTuition(null);
        if (s14 && !s13 && !multiChild) navigate(`/decision${childQ}`);
      })
      .finally(() => setTuitionLoading(false));
  }, [stages]);

  const columns = [
    {
      title: "Шат",
      key: "title",
      render: (_, row) => <div style={{ fontWeight: 600, fontSize: 14 }}>{row.title || `${row.level}-р шат`}</div>,
    },
    {
      title: "Төлөв",
      key: "status",
      width: 180,
      render: (_, row) => {
        if (row.stageId === 13) return null;
        if (row.resultSent && row.status === "Accept") return <Tag color="success">✓ Тэнцсэн</Tag>;
        if (row.resultSent && row.status === "Reject") return <Tag color="error">Тэнцээгүй</Tag>;
        if (row.processStatus === "submitted") return <Tag color="warning">Хянагдаж байна</Tag>;
        if (row.processStatus === "filled") return <Tag color="orange">Дутуу</Tag>;
        return <Tag color="default">Хүлээгдэж байна</Tag>;
      },
    },
    {
      title: "Хариу",
      key: "action",
      width: 180,
      render: (_, row) => {
        if (!row.resultSent) return <span style={{ color: "#bbb", fontSize: 13 }}>—</span>;

        if ((row.stageId === 13 || row.stageId === 14) && row.status === "Reject")
          return <span style={{ fontSize: 13, color: "#888" }}>📧 Таны хариу мэйлд очсон</span>;

        if ((row.stageId === 13 || row.stageId === 14) && row.status === "Accept")
          return (
            <Button size="small"
              style={{ background: "#f3eaff", borderColor: C.purple, color: C.purple, fontWeight: 600 }}
              onClick={() => {
                if (row.resultViewed !== 1) {
                  instance({ method: "post", url: `/applicant2/result/viewed`, data: { stageId: row.stageId, applicantId: selectedId || undefined } }).catch(() => { });
                }
                navigate(`/decision${childQ}`);
              }}>
              Хариу харах
            </Button>
          );

        const isViewed = row.resultViewed === 1;
        return (
          <Button size="small"
            style={{
              background: isViewed ? "#fff" : (row.status === "Accept" ? "#f3eaff" : "#fff"),
              borderColor: isViewed ? "#d9d9d9" : (row.status === "Accept" ? C.purple : "#d9d9d9"),
              color: isViewed ? "#999" : (row.status === "Accept" ? C.purple : "#555"),
              fontWeight: 600,
            }}
            onClick={() => {
              setModalStage(row);
              if (!isViewed) {
                instance({ method: "post", url: `/applicant2/result/viewed`, data: { stageId: row.stageId, applicantId: selectedId || undefined } })
                  .then(() => setStages(prev => prev.map(s => s.stageId === row.stageId ? { ...s, resultViewed: 1 } : s)))
                  .catch(() => { });
              }
            }}>
            {isViewed ? "Харсан" : "Хариу харах"}
          </Button>
        );
      },
    },
  ];

  const stage13Accepted = stages.find(s => s.stageId === 13 && s.resultSent && s.status === "Accept");
  const stage14Accepted = stages.find(s => s.stageId === 14 && s.resultSent && s.status === "Accept");
  const tuitionReady = !!tuition;

  // ── Stage 13 Accept доор харагдах нэг блок ──
  // tuition бэлэн  → төлбөр
  // finAid хүссэн  → jotform
  // бусад          → "удахгүй имэйл"
  const renderStage13Block = () => {
    if (!stage13Accepted && !stage14Accepted) return null;

    if (tuitionReady) {
      return (
        <div style={{
          marginTop: 20, padding: "18px 24px", background: "#f3eaff",
          borderRadius: 10, border: "1.5px solid #d8b4fe",
          display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16,
        }}>
          <div>
            <div style={{ fontWeight: 700, color: "#5c1090", fontSize: 14, marginBottom: 4 }}>
              💳 Сургалтын төлбөрийн мэдээлэл
            </div>
            <div style={{ fontSize: 13, color: "#7B2FBE" }}>
              Таны төлбөрийн мэдээлэл бэлэн болсон байна.
            </div>
          </div>
          <button onClick={() => navigate(`/payment${childQ}`)} style={{
            flexShrink: 0, background: "#5c1090", color: "#fff",
            borderRadius: 8, padding: "10px 20px", fontSize: 13,
            fontWeight: 700, border: "none", cursor: "pointer",
          }}>
            Төлбөрийн мэдээлэл харах →
          </button>
        </div>
      );
    }

    if (finAid) {
      return (
        <div style={{
          marginTop: 20, padding: "18px 24px", background: "#eff6ff",
          borderRadius: 10, border: "1.5px solid #bfdbfe",
          display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16,
        }}>
          <div>
            <div style={{ fontWeight: 700, color: "#1e40af", fontSize: 14, marginBottom: 4 }}>
              📋 Санхүүгийн дэмжлэгийн өргөдөл
            </div>
            <div style={{ fontSize: 13, color: "#3b82f6" }}>
              {tuitionLoading
                ? "Мэдээлэл шалгаж байна..."
                : "Та санхүүгийн дэмжлэг хүссэн тул доорх формыг бөглөнө үү."}
            </div>
          </div>
          <a href="https://form.jotform.com/260808191613456" target="_blank" rel="noreferrer"
            style={{
              flexShrink: 0, display: "inline-block", background: "#1e40af",
              color: "#fff", borderRadius: 8, padding: "10px 20px",
              fontSize: 13, fontWeight: 700, textDecoration: "none",
            }}>
            Өргөдөл бөглөх →
          </a>
        </div>
      );
    }

    return (
      <div style={{
        marginTop: 20, padding: "18px 24px", background: "#f3eaff",
        borderRadius: 10, border: "1.5px solid #d8b4fe",
      }}>
        <div style={{ fontWeight: 700, color: "#5c1090", fontSize: 14, marginBottom: 4 }}>
          💳 Сургалтын төлбөрийн мэдээлэл
        </div>
        <div style={{ fontSize: 13, color: "#7B2FBE" }}>
          {tuitionLoading
            ? "Мэдээлэл шалгаж байна..."
            : "Тун удахгүй бид танд төлбөр болон бүртгэлийн дэлгэрэнгүй мэдээллийг имэйлээр илгээх болно."}
        </div>
      </div>
    );
  };

  return (
    <div className="flex flex-col items-center min-h-screen relative">
      <div className="mt-16 w-full flex justify-center">
        <div className="m-8 w-4/5">

          <div className="gap-4 mx-auto py-20 md:py-0 mb-8">
            <div className="text-[20pt] md:text-[20pt] xl:text-[30pt] font-extrabold text-primary leading-[1.38]">
              Сайн уу {selectedChild?.firstName || name},
            </div>
            <div style={{ marginTop: 8, color: "#555", fontSize: 15 }}>
              {multiChild
                ? "Та нэг хаягаасаа хүүхэд бүрийнхээ элсэлтийн явцыг хянах боломжтой."
                : "Таны Томүжин Алтернатив сургуулийн элсэлтийн үе шатуудын явц доор харагдана."}
            </div>
          </div>

          {/* ── Хүүхэд сонгогч — нэг логинд хэд хэдэн өргөдөл холбогдсон үед ── */}
          {multiChild && (
            <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginBottom: 20 }}>
              {children.map((c) => {
                const active = c.id === selectedId;
                return (
                  <button
                    key={c.id}
                    onClick={() => handleSelectChild(c.id)}
                    style={{
                      cursor: "pointer",
                      padding: "10px 18px",
                      borderRadius: 10,
                      fontSize: 14,
                      fontWeight: 700,
                      border: active ? `2px solid ${C.purple}` : "2px solid #e5e7eb",
                      background: active ? "#f3eaff" : "#fff",
                      color: active ? "#5c1090" : "#555",
                      transition: "all .15s",
                    }}
                  >
                    {c.firstName}
                    <span style={{ fontWeight: 500, fontSize: 12, marginLeft: 6, color: active ? "#7B2FBE" : "#999" }}>
                      {c.grade ? `${c.grade}-р анги` : ""}
                    </span>
                  </button>
                );
              })}
            </div>
          )}

          <Table
            columns={columns}
            dataSource={stages}
            rowKey="stageId"
            pagination={false}
            loading={loading}
            locale={{ emptyText: "Мэдээлэл байхгүй байна" }}
          />

          {renderStage13Block()}

        </div>
      </div>

      <ResultModal
        open={!!modalStage}
        onClose={() => setModalStage(null)}
        stage={modalStage}
        finAid={finAid}
        name={selectedChild?.firstName || name}
        tuitionReady={tuitionReady}
      />
    </div>
  );
}

export default ApplicantHome;